import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import {
    fetchCountiesForZipcodeFailure,
    fetchCountiesForZipcodeSuccess,
    setCounty
} from '../../actions/ssap/ssapActionCreators';

export function* countiesForZipcodeSaga(action) {
    try {
        const {
            pageName,
            postalCode,
            state
        } = action;

        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const counties = yield call([ssapService, ssapService.getCountiesForZipcode], { postalCode, state });
        if(counties) {
            yield put(setCounty(counties, pageName));
            yield put(fetchCountiesForZipcodeSuccess());
        } else {
            yield put(fetchCountiesForZipcodeFailure());
        }
    } catch(e) {
        yield put(fetchCountiesForZipcodeFailure());
    }
}